const formats = [
  { icon: 'ri-building-2-line', title: 'Корпоративная академия под ключ', desc: 'Полный цикл: диагностика, проектирование, создание программ, подготовка тренеров, запуск и сопровождение. Вы получаете работающую систему обучения.' },
  { icon: 'ri-lightbulb-flash-line', title: 'Консалтинг', desc: 'Экспертная поддержка на любом этапе: аудит текущей системы, проектирование академии, разработка методологии, внедрение отдельных элементов.' },
  { icon: 'ri-presentation-line', title: 'Корпоративное обучение', desc: 'Тренинги и бизнес-игры для сотрудников и руководителей как часть академии. Развитие конкретных компетенций по запросу бизнеса.' },
  { icon: 'ri-user-voice-line', title: 'Подготовка внутренних тренеров', desc: 'Программа Train the Trainer: отбор, обучение методике, практика, сертификация. Компания получает собственный тренерский состав.' },
  { icon: 'ri-user-star-line', title: 'Школа руководителей', desc: 'Системная программа развития управленческих компетенций: от линейного руководителя до топ-менеджмента. Лидерство, делегирование, стратегия.' },
  { icon: 'ri-user-add-line', title: 'Система адаптации', desc: 'Разработка и внедрение онбординга: welcome-программа, чек-листы, наставничество, оценка. Новички выходят на KPI в 2 раза быстрее.' },
  { icon: 'ri-folder-open-line', title: 'Разработка базы знаний', desc: 'Создание единого хранилища: регламенты, скрипты, видеоуроки, книги продаж. Знания компании систематизированы и доступны каждому.' },
  { icon: 'ri-heart-pulse-line', title: 'Сопровождение', desc: 'Постпроектная поддержка: коучинговые сессии, разбор кейсов, корректировка программ. Академия продолжает развиваться после запуска.' },
];

export default function WorkFormats() {
  return (
    <section id="formats" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Форматы работы
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Выберите формат под ваши задачи — от полного создания академии до экспертной поддержки на конкретном этапе
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {formats.map((f, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 border border-gray-200 hover:border-teal-300 hover:shadow-md transition-all group text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${f.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{f.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}